export default __webpack_public_path__ + "static/media/Frame (1).15a422a7.png";